export default __webpack_public_path__ + "static/media/viewer-lite.69730ee6.gif";